import { useEffect, useState } from "react";
import SystemModal from "../Common/SystemModal";
import Loader from "../Common/Loader";
import { toast } from "react-hot-toast";
import ajaxAccounting from "../../util/remote/ajaxAccounting";
import Select from "react-select";

const TransactionCostAllocationDetails = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(props.item);

  const [CACInfo, setCACInfo] = useState("");
  const FetchTransactions = async () => {
    const payload = {
      trans_reff: props.reference,
    };
    setCACInfo("");
    setLoading(true);
    const server_response =
      await ajaxAccounting.getPaymentVoucher_costAllocation(payload);
    setLoading(false);
    if (server_response.status === "OK") {
      setCACInfo(server_response.details);
    } else {
      setCACInfo("404");
    }
  };

  const delete_cost_item = async (e, id) => {
    e.preventDefault();
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this item ?"
    );

    if (isConfirmed) {
      var dataa = {
        id: id,
        reference: props.reference,
        amount: data.amount.amount,
      };
      const server_response =
        await ajaxAccounting.delete_transaction_costAllocation(dataa);

      if (server_response.status === "OK") {
        toast.success(server_response.message);
        FetchTransactions();
      } else {
        toast.error(server_response.message);
      }
    }
  };
  useEffect(() => {
    FetchTransactions();
  }, []);
  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}
          >
            Close
          </button>
        </>
      );
    }
  };

  return (
    <SystemModal
      title="Transaction cost allocation item"
      id="model-new-ledger"
      size="lg"
      footer={RenderFooter}
    >
      <div
        className="mb-4 col-md-12"
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          borderBottom: "dotted 1px grey",
          backgroundColor: "transparent",
        }}
      >
        <div className="">
          <ul>
            <li>
              <span>
                Account_debited:{" "}
                <u>{data && data.ledgerID_debited.Ledger_name}</u>
              </span>
            </li>
            <li>
              <span>
                Account_credited:{" "}
                <u>{data && data.ledgerID_credited.Ledger_name}</u>
              </span>
            </li>
          </ul>
        </div>
        <div className="">
          <ul>
            <li>
              <span>
                Total_of_transaction: <u>{data && data.amount.amount_c}</u>
              </span>
            </li>
            <li>
              <span>
                amount_un_Allocated:{" "}
                <u>{data && data.cat_balance.cat_balance_c}</u>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <table
            className="table table-striped table-bordered"
            style={{ border: "orange 3px groove" }}
          >
            <thead>
              <th>#</th>
              <th>cost Allocatio Item </th>
              <th>Amount</th>
              <th>Description</th>
              <th>reciever</th>
              <th>Date</th>
              {/* <th>Action</th> */}
              {/* {"id": "1289",}, */}
            </thead>
            <tbody>
              {Array.isArray(CACInfo) &&
                CACInfo.map((item, key) => (
                  <tr key={key}>
                    <td>{key + 1}</td>
                    <td>{item.catID.item}</td>
                    <td>{item.amount.amount_c}</td>
                    <td>{item.description}</td>
                    <td>{item.reciever}</td>
                    <td>{item.date.short_date}</td>
                    {/* <td>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-evenly",
                        }}
                        class="btn btn-list"
                      >
                        <button
                          style={{
                            borderRadius: "10px",
                            fontSize: "14px",
                            height: "10px",
                            margin: "2px",
                            color: "white",
                            background:
                              "linear-gradient(to right,rgb(245, 24, 24),rgba(219, 190, 60, 0.781))",
                          }}
                          onClick={(e) => delete_cost_item(e, item.id)}
                          className="btn ripple btn-outline-success btn-with-icon"
                          to="#"
                        >
                          <i class="fa-solid fa-trash-can-arrow-up"></i>
                          &nbsp;
                          <span className="sidemenu-label"></span>
                        </button>{" "}
                      </div>
                    </td> */}
                  </tr>
                ))}

              {CACInfo === "404" && (
                <>
                  <tr>
                    <td colSpan={10}>
                      <p className="text-center text-info">
                        No data found in the system
                      </p>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </SystemModal>
  );
};

export default TransactionCostAllocationDetails;
